var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapseAll = function SvgCollapseAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.67 14.977a.6.6 0 0 1 .754.078l5.797 5.797a.6.6 0 0 1-.848.848L12 16.326 6.627 21.7a.6.6 0 0 1-.848-.848l5.797-5.797zm5.703-12.676a.6.6 0 0 1 .848.847l-5.797 5.798a.6.6 0 0 1-.848 0L5.779 3.148a.599.599 0 1 1 .848-.847L12 7.673z"
  })));
};
export default SvgCollapseAll;